import React from "react";

export const MagnifyingGlass = (props) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.75C4 6.8505 6.3505 4.5 9.25 4.5C12.1495 4.5 14.5 6.8505 14.5 9.75C14.5 11.1645 13.9406 12.4483 13.031 13.3923C13.0054 13.412 12.9807 13.4337 12.9572 13.4572C12.9336 13.4807 12.912 13.5054 12.8923 13.531C11.9483 14.4406 10.6645 15 9.25 15C6.3505 15 4 12.6495 4 9.75ZM13.4633 15.0239C12.3085 15.9476 10.8438 16.5 9.25 16.5C5.52208 16.5 2.5 13.4779 2.5 9.75C2.5 6.02208 5.52208 3 9.25 3C12.9779 3 16 6.02208 16 9.75C16 11.3438 15.4476 12.8085 14.5239 13.9633L17.2803 16.7197C17.5732 17.0126 17.5732 17.4874 17.2803 17.7803C16.9874 18.0732 16.5126 18.0732 16.2197 17.7803L13.4633 15.0239Z"
        fill={props.fill}
      />
    </svg>
  );
};

export default MagnifyingGlass;
